export const getSmallestArrays = (arrays) => {
    const minLength = Math.min(...arrays.map((arr) => arr.length));
    return arrays.filter((arr) => arr.length <= minLength);
};
